import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { isNil, isEmpty } from 'ramda';
import { Link } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import { optional } from '../utilities';
import Page from './Page';
import SecondHandBoardgameListItem from './SecondHandBoardgameListItem';
import IconRecycling from './IconRecycling';

class SecondHandBoardgamesListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
    };
    this.queryRef = React.createRef();

    this.onChangeQuery = this.onChangeQuery.bind(this);
    this.onClearQueryClick = this.onClearQueryClick.bind(this);
  }

  componentDidMount() {
    ReactPixel.pageView();
    this.props.getSecondHandBoardgames();
  }

  onChangeQuery(event) {
    event.preventDefault();
    event.persist();
    this.setState({ query: event.target.value || '' });
  }

  onClearQueryClick() {
    this.setState({ query: '' });
    if (this.queryRef) {
      this.queryRef.current.focus();
    }
  }

  render() {
    const filteredBoardgames = this.props.boardgames
      .filter(bg => bg.title.toLocaleLowerCase().includes(this.state.query.trim().toLocaleLowerCase()));

    return (
      <React.Fragment>
        <Helmet>
          <title>Replay - Smart Gaming</title>
        </Helmet>
        <Page>
          <div className="mb-2 md:mb-4 md:px-20">
            <div className="flex justify-center">
              <IconRecycling className="w-16 mb-2" />
            </div>
            <h1 className="font-serif text-2xl md:text-4xl font-black leading-tight text-center mb-2">Smart Gaming Replay</h1>
            <p className="text-center text-lg">I migliori giochi da tavolo usati, a un prezzo smart.</p>
            <p className="text-center mt-6">
              Vuoi fare spazio nella tua libreria per qualche nuovo titolo e non sai come fare?
              <br />
              Scrivici una mail a <a className="font-bold hover:underline" href="mailto:replay@smart-gaming.it?subject=[Nuova inserzione] <titolo>">replay@smart-gaming.it</a>, specificando il titolo del gioco, una breve descrizione del suo stato, qualche foto e il prezzo a cui desideri rivenderlo. Aggiungeremo il tuo annuncio a questa pagina e ti faremo sapere se qualcuno è interessato al tuo gioco!
            </p>
          </div>
          <div className="flex justify-center flex-col md:flex-row p-4 md:w-2/3 w-full mx-auto mb-2 md:mb-4">
            <div className="md:inline-block relative w-full md:pl-2 md:mt-0 md:mr-3">
              <div className="block relative">
                <div className="absolute inset-y-0 left-0 flex items-center px-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#cbd5e0" d="M23.832 19.641l-6.821-6.821c2.834-5.878-1.45-12.82-8.065-12.82-4.932 0-8.946 4.014-8.946 8.947 0 6.508 6.739 10.798 12.601 8.166l6.879 6.879c1.957.164 4.52-2.326 4.352-4.351zm-14.886-4.721c-3.293 0-5.973-2.68-5.973-5.973s2.68-5.973 5.973-5.973c3.294 0 5.974 2.68 5.974 5.973s-2.68 5.973-5.974 5.973z"/>
                  </svg>
                </div>
                <input
                  className="appearance-none border border-gray-400 rounded-full w-full py-2 px-10 text-gray-700 leading-tight focus:outline-none focus:shadow"
                  type="text"
                  placeholder="Cerca"
                  value={this.state.query}
                  onChange={this.onChangeQuery}
                  ref={this.queryRef} />
                {
                  !isNil(this.state.query) && !isEmpty(this.state.query) &&
                    <button type="button" onClick={this.onClearQueryClick} className="absolute inset-y-0 right-0 flex items-center px-4 cursor-pointer text-gray-700">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                      <path fill="#cbd5e0" d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>
                    </svg>
                  </button>
                }
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center">
            {
              filteredBoardgames
                .map(bg => (
                  <Link key={bg.id} className="w-full md:w-2/5 lg:w-1/4 md:mx-4 md:mb-8" to={`/replay/${bg.id}`}>
                    <SecondHandBoardgameListItem boardgame={bg} onClick={this.onBoardgameClick}/>
                  </Link>
                ))
            }
            {
              filteredBoardgames.length === 0 && !this.props.loading &&
                <div>
                  <h1 className="font-serif text-xl py-4 text-center font-bold">Purtroppo non abbiamo nessun gioco che corrisponde ai tuoi criteri di ricerca.</h1>
                  <p className="text-center">Non essere triste! Ritorna a trovarci fra qualche tempo: Smart Gaming Replay è in continuo aggiornamento.</p>
                </div>
            }
            {
              optional(this.props.boardgames, []).length === 0 && !this.props.loading &&
                <div>
                  <h1 className="font-serif text-xl py-4 text-center font-bold">Purtroppo non abbiamo nessun annuncio al momento.</h1>
                  <p className="text-center">Non essere triste! ritorna a trovarci fra qualche tempo: Smart Gaming Replay è in continuo aggiornamento.</p>
                </div>
            }
          </div>
        </Page>
      </React.Fragment>
    );
  }
}

export default SecondHandBoardgamesListPage;
